import styles from './Subtitle.css';

export function Subtitle({ text }: { text: string }): JSX.Element {
  return (
    <h3 className={styles['subtitle']} data-testid="card.subtitle">
      {text}
    </h3>
  );
}
